import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button, ListGroup, ListGroupItem, Spinner } from 'reactstrap';
import moment from 'moment';

import actions from './actions';
import actionsGuiaInterativo from '../../actions';
import { Step } from '../guiaInterativo/constants';

class ContratadosPresentes extends Component {
  componentDidMount() {
    this.props.actions.onLoadPresencas();
  }

  render() {
    let {
      value: { result, fetching },
      actions,
      actionsGuiaInterativo
    } = this.props;

    return (
      <ListGroup className="lcp-container">
        {result.map((v, i) => (
          <ListGroupItem
            key={i}
            className="lcp-container-row d-flex justify-content-between align-items-center"
          ><details><summary>
            {moment(v.checkin).format('HH:mm')} : {v.contratado.nome}
            <br />
            {0 !== parseInt(v.contratante.apartamento, 10) ? v.contratante.text : ''}
            </summary><ul>
              <li>{v.contratado.funcao.nome}</li>
              {v.contratado.empresa.nome && <li>{v.contratado.empresa.nome}</li>}
            </ul></details><Button
              className="lcp-button-checkout"
              color="danger"
              onClick={() => {
                actions
                  .onCheckout(v)
                  .then(() => {
                    actionsGuiaInterativo.abrirGuiaSeNecessario(
                      Step.CADASTRO_CONTRATADO_EXCLUSAO
                    );
                  })
                  .catch(v => {
                    alert(v.message);
                  });
              }}
              title="Acabou de sair!"
            >
              <span className="fa fa-user-times" />{' '}
              <span className="d-none d-sm-inline-block">Acabou de sair!</span>
            </Button>
          </ListGroupItem>
        ))}
        {1 === fetching && !result.length && (
          <ListGroupItem color="dark">
            <Spinner size="sm" color="dark" /> Obtendo lista de prestadores presentes...
          </ListGroupItem>
        )}
        {2 === fetching && !result.length && (
          <ListGroupItem color="success">
            Obrigado por manter os registros atualizados!
          </ListGroupItem>
        )}
        {0 < result.length && (
          <ListGroupItem className="lcp-rodape" color="warning">
            Lembre-se de registrar a saída do prestador.
          </ListGroupItem>
        )}
      </ListGroup>
    );
  }
}

let mapStateToProps = ({ registroAcesso, guiaInterativo }) => ({
  value: registroAcesso.presencas,
  guiaInterativo
});

let mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch),
  actionsGuiaInterativo: bindActionCreators(actionsGuiaInterativo, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ContratadosPresentes);



// WEBPACK FOOTER //
// ./src/modules/registroAcesso/ContratadosPresentes.js